module.exports = __webpack_public_path__ + "img/beranda-karir.9034972d.webp";